module.exports = __webpack_public_path__ + "img/Group 20.c39404e1.png";